import React, { useState, useRef, useEffect } from 'react';
import './DropdownMenu.css'; // Import the CSS file for styling

function DropdownMenu({
    label,               // Label for the dropdown button
    options,             // Array of options [{ value: 'value1', label: 'Label 1' }, ...]
    selectedValue,       // Currently selected value
    onOptionSelect,      // Callback when an option is selected
    className,           // Additional class names for styling
    buttonClassName,     // Class name for the dropdown button
    menuClassName,       // Class name for the dropdown menu
    optionClassName,     // Class name for each dropdown option
    style,               // Inline styles for the dropdown container
    buttonStyle,         // Inline styles for the dropdown button
    menuStyle,           // Inline styles for the dropdown menu
    optionStyle,         // Inline styles for each option
}) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => setIsOpen(prevIsOpen => !prevIsOpen);

    const handleOptionClick = (value) => {
        onOptionSelect(value);
        setIsOpen(false);
    };

    // Close the dropdown if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Handle keyboard navigation
    const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
            setIsOpen(false);
        }
    };

    return (
        <div
            className={`dropdown-container ${className || ''}`}
            ref={dropdownRef}
            style={style}
            onKeyDown={handleKeyDown}
        >
            <button
                type="button"
                className={`dropdown-button ${buttonClassName || ''}`}
                onClick={toggleDropdown}
                style={buttonStyle}
                aria-haspopup="listbox"
                aria-expanded={isOpen}
            >
                {label} {options.find(opt => opt.value === selectedValue)?.label || 'Select'}
                <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</span>
            </button>
            {isOpen && (
                <ul
                    className={`tkmr-dropdown-menu ${menuClassName || ''}`}
                    style={menuStyle}
                    role="listbox"
                >
                    {options.map((option) => (
                        <li
                            key={option.value}
                            className={`dropdown-item ${optionClassName || ''}`}
                            style={optionStyle}
                            onClick={() => handleOptionClick(option.value)}
                            role="option"
                            aria-selected={option.value === selectedValue}
                        >
                            {option.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default DropdownMenu;
